import Button from '@components/ui/ButtonV2/Button'
import { SetFullScreenModal } from '@customTypes/setFullScreenModal'
// import { useCustomerDelete } from '@features/account/api/customer-delete'
// import { CustomerAccountDeleteMutation } from '@lib/graphql/graphql'
import { useCustomErrors } from '@lib/hooks/useCustomErrors'
import { selectModalProps } from '@redux/modalSlice'
import { useAppSelector } from '@redux/store'
import { FC } from 'react'
import s from './DeleteAccountModal.module.scss'

interface Props {
  onClose: () => void
}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type DeleteAccountModalProps = Props & NativeAttrs & SetFullScreenModal

const DeleteAccountModal: FC<DeleteAccountModalProps> = ({ onClose }) => {
  const modalProps = useAppSelector(selectModalProps)
  const { data } = modalProps

  // const { mutateAsync, isPending } = useCustomerDelete()

  const { customErrors, loading, addError, clearErrors } = useCustomErrors()

  // const onDelete = async () => {
  //   try {
  //     const response = (await mutateAsync({
  //       data,
  //     })) as CustomerAccountDeleteMutation

  //     if (response.customerAccountDelete.customer.id) {
  //       clearErrors()

  //       const x = await signOut({
  //         redirect: true,
  //       })
  //     }
  //   } catch (error) {
  //     console.error(error)

  //     addError({
  //       code: 'unknown',
  //       message: 'Something went wrong',
  //     })
  //   }
  // }

  return (
    <div className={s.root}>
      <div className={s.section}>
        <div className={s.headline}>DELETE ACCOUNT</div>
        <p>
          Are you sure you want to delete your account? Please keep in mind that
          this action cannot be undone.
        </p>
      </div>

      <div className={s.section}>
        {customErrors && customErrors.length > 0 && (
          <div className={s.errorContainer}>
            {customErrors.map((error) => (
              <div key={error.code} className={s.error}>
                {error.message}
              </div>
            ))}
          </div>
        )}

        <Button
          size="small"
          variant="secondary"
          // onClick={onDelete}
          // loading={isPending || loading}
        >
          Delete
        </Button>
        <Button as="a" size="small" variant="buy" onClick={onClose}>
          Cancel
        </Button>
      </div>
    </div>
  )
}

export default DeleteAccountModal
